import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";

@Component({
  selector: "okr-attainment-picker",
  templateUrl: "./attainment-picker.component.html",
  styleUrls: ["./attainment-picker.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OkrAttainmentPickerComponent {
  @Input() public goalAttainmentType: string;
  @Input() public allowEditGoalFields: boolean;

  @Output() public readonly switchProgressCalculateType: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("firstListItem", { static: true }) public readonly firstListItem: ElementRef;
  @ViewChild("dropdownMenuButton", { static: true, read: ElementRef }) public dropdownMenuButton: ElementRef<HTMLElement>;

  public onProgressCalculateTypeChange(type: string): void {
    this.switchProgressCalculateType.emit(type);
  }

  public handleKeydown(event: KeyboardEvent, type: string): void {
    if (event.key === "Enter") {
      event.preventDefault();
      this.onProgressCalculateTypeChange(type);
    }
  }

  public openDropdownMenu(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      event.preventDefault();
      this.dropdownMenuButton.nativeElement.click();
    }
  }

  public onDropdownMenuOpen(input: boolean): void {
    if (input) {
      setTimeout(() => {
        this.firstListItem.nativeElement.focus();
      }, 100);
    }
  }
}
